/**
 * Коэффициенты для определения типа фото по aspect ratio
 * aspect ratio = width / height
 */
export const ASPECT_RATIO_THRESHOLDS = {
  /** Минимальный коэффициент для квадратного фото */
  SQUARE_MIN: 0.95,
  /** Максимальный коэффициент для квадратного фото */
  SQUARE_MAX: 1.05,
} as const;
